goog.provide("shadow.js.shim.module$$mui$material$Tooltip");
goog.provide("module$shadow_js_shim_module$$mui$material$Tooltip");
shadow.js.shim.module$$mui$material$Tooltip = shadow.js.nativeProvides["@mui/material/Tooltip"] = shadow$bridge("@mui/material/Tooltip");
module$shadow_js_shim_module$$mui$material$Tooltip.default = shadow.js.shim.module$$mui$material$Tooltip;
